import {round} from './Internal/round';

export function formatRSquared(rSquared: number | null): {
    formatted: string;
    unit?: string;
} {
    if (rSquared === null) {
        return {formatted: '-'};
    }
    return {formatted: round(rSquared * 100, 2), unit: '%'};
}

export function formatAverageRSquared(rSquared: number | null): {
    formatted: string;
    unit?: string;
} {
    if (rSquared === null) {
        return {formatted: '-'};
    }
    return {formatted: round(rSquared * 100, 2), unit: '%'};
}
